import { useAuth } from './useAuth'

/**
 * Primitiva de autorização da UI. Espelha o backend (has_permission):
 * staff_admin (is_superuser) pode tudo; os demais dependem das permissões
 * concedidas. A segurança real é no servidor — isto só molda a interface.
 *
 *   const can = useCan()
 *   {can('contracts.create') && <BotaoNovo />}
 */
export function useCan(): (key: string) => boolean {
  const { user } = useAuth()
  return (key: string) => Boolean(user && (user.is_superuser || user.permissions?.includes(key)))
}
